import { Company } from '../shared/enums';
import { CompanyConfig } from './company.config.interface';

export const companyConfig: CompanyConfig = {
  // Videos
  howToCompleteTimesheetVideoId: {
    [Company.tns]: 'UnOYcoet-g8',
    [Company.sng]: '9a5eHS3jPFI',
  },
  howToBookYourFirstShiftVideoId: {
    [Company.tns]: '7bC1eb8O94s',
    [Company.sng]: 'nHfSVzvc7u8',
  },
  howToUseQuickNurseVideoId: {
    [Company.tns]: 'MDO_iYiYP5M',
    [Company.sng]: 'U5qt8d0czV4',
  },
  // Header
  headerSvgId: {
    [Company.tns]: 'logo-tns',
    [Company.sng]: 'logo-sng',
  },
  // Shared
  companyDescriptor: {
    [Company.tns]: 'Thornbury Nursing Services',
    [Company.sng]: 'Scottish Nursing Guild',
  },
  companyShortDescriptor: {
    [Company.tns]: 'Thornbury',
    [Company.sng]: 'the Guild',
  },
  companyShortestDescriptor: {
    [Company.tns]: 'Thornbury',
    [Company.sng]: 'Guild',
  },
  companyAlternativeShortDescriptor: {
    [Company.tns]: 'Thornbury',
    [Company.sng]: 'Nursing Guild',
  },
  companyDashboardDescriptor: {
    [Company.tns]: 'Thornbury Compliance Portal',
    [Company.sng]: 'Nursing Guild Compliance Portal',
  },
  rtcEmail: {
    [Company.tns]: 'rtc@tnsltd.com',
    [Company.sng]: 'training@nursingguild.com',
  },
  referencesEmail: {
    [Company.tns]: 'references@tnsltd.com',
    [Company.sng]: 'references@nursingguild.com',
  },
  agencyNurseHandbook: {
    [Company.tns]:
      'https://library.thornbury-nursing.com/TNS_SNG_Agency_Worker_Handbook.pdf',
    [Company.sng]:
      'https://library.thornbury-nursing.com/TNS_SNG_Agency_Worker_Handbook.pdf',
  },
  welcomeCallPhone: {
    [Company.tns]: '0345 120 5305',
    [Company.sng]: '',
  },
  welcomeCallEmail: {
    [Company.tns]: 'welcomecall@tnsltd.com',
    [Company.sng]: 'welcomecall@nursingguild.com',
  },
  welcomeCallCalendarTitle: {
    [Company.tns]: 'Thornbury Nursing Welcome Call',
    [Company.sng]: 'Scottish Nursing Guild Welcome Call',
  },
  // Resources
  nmcNmbiRenewalTsAndCs: {
    [Company.tns]:
      'https://thornbury-nursing.com/nmc-renewal-fee-terms-and-conditions/',
    [Company.sng]:
      'https://scottish-nursing-guild.com/nmc-and-nmbi-renewal-terms-and-conditions/',
  },
  // Revalidation
  revalidationAccountsTemplate: {
    [Company.tns]:
      'https://library.thornbury-nursing.com/revalreflectiveaccounts.pdf',
    [Company.sng]:
      'https://library.scottish-nursing-guild.com/revalreflectiveaccounts.pdf',
  },
  revalidationComplaintsForm: {
    [Company.tns]:
      'https://www.thornbury-quick-nurse.com/documents/revalcomplaints.pdf',
    [Company.sng]:
      'https://www.scottish-quick-nurse.com/documents/revalcomplaints.pdf',
  },
  revalidationConfirmationTemplate: {
    [Company.tns]:
      'https://www.thornbury-quick-nurse.com/documents/revalconfirmation.pdf',
    [Company.sng]:
      'https://www.scottish-quick-nurse.com/documents/revalconfirmation.pdf',
  },
  revalidationCpdTemplate: {
    [Company.tns]: 'https://library.thornbury-nursing.com/revalcpdlog.pdf',
    [Company.sng]: 'https://library.scottish-nursing-guild.com/revalcpdlog.pdf',
  },
  revalidationDiscussionTemplate: {
    [Company.tns]:
      'https://www.thornbury-quick-nurse.com/documents/revalreflectiveform.pdf',
    [Company.sng]:
      'https://www.scottish-quick-nurse.com/documents/revalreflectiveform.pdf',
  },
  revalidationPracticeFeedbackForm: {
    [Company.tns]:
      'https://www.thornbury-quick-nurse.com/documents/revalPRACTICERELATEDFEEDBACKFORM.pdf',
    [Company.sng]:
      'https://www.scottish-quick-nurse.com/documents/revalPRACTICERELATEDFEEDBACKFORM.pdf',
  },
  revalidationPracticeHoursTemplate: {
    [Company.tns]: 'https://library.thornbury-nursing.com/revalpracticelog.pdf',
    [Company.sng]:
      'https://library.scottish-nursing-guild.com/revalpracticelog.pdf',
  },
  revalidationRevalidationGuide: {
    [Company.tns]:
      'https://www.thornbury-quick-nurse.com/documents/revalguide.pdf',
    [Company.sng]:
      'https://www.scottish-quick-nurse.com/documents/revalguide.pdf',
  },
  revalidationSamplePortfolio: {
    [Company.tns]:
      'https://www.thornbury-quick-nurse.com/documents/revalsampleportfolio.pdf',
    [Company.sng]:
      'https://www.scottish-quick-nurse.com/documents/revalsampleportfolio.pdf',
  },
  revalidationVerbalFeedbackForm: {
    [Company.tns]:
      'https://www.thornbury-quick-nurse.com/documents/revalverbal.pdf',
    [Company.sng]:
      'https://www.scottish-quick-nurse.com/documents/revalverbal.pdf',
  },
  revalidationLogIn: {
    [Company.tns]: 'https://online.nmc-uk.org/Account/Login',
    [Company.sng]: 'https://online.nmc-uk.org/Account/Login',
  },
  revalidationRegister: {
    [Company.tns]: 'https://www.nmc.org.uk/registration/nmc-online/',
    [Company.sng]: 'https://www.nmc.org.uk/registration/nmc-online/',
  },
  revalidationCpdTrainingCourses: {
    [Company.tns]: 'https://thornbury-nursing.com/join-thornbury/cpd/',
    [Company.sng]: 'https://scottish-nursing-guild.com/join-the-guild/cpd/',
  },
  revalidationRevalidationForum: {
    [Company.tns]: 'https://www.facebook.com/groups/tnssngrevalidation',
    [Company.sng]: 'https://www.facebook.com/groups/tnssngrevalidation',
  },
  revalidationWatchNow: {
    [Company.tns]: 'https://www.youtube.com/watch?v=bY8gWlOhh0Y',
    [Company.sng]: 'https://www.youtube.com/watch?v=bY8gWlOhh0Y',
  },
};
